import { RemoveSheqManagerDialog } from "./components/RemoveSheqManagerDialog";

export default RemoveSheqManagerDialog;